export default __webpack_public_path__ + "static/media/Facebook.295f47bd.svg";